import { render, staticRenderFns } from "./PER.vue?vue&type=template&id=00f3d810&"
import script from "./PER.vue?vue&type=script&lang=js&"
export * from "./PER.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports